import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function EULA() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
             <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

    <main className="terms-container faq  terms-nd-condition my-3">
      <div  className={`container ${styles.container}`}>
      <header className="terms-header">
      </header>
      </div>
    </main>
   <main className="terms-container faq  terms-nd-condition my-3">
       <div  className={`container ${styles.container}`}>
       <header className="terms-header">
         <h1 className='main-heading text-left'>Resumate End User License Agreement (EULA)</h1>
         <p>Last Updated: October 1, 2025</p>
         <p>
          This End User License Agreement (“Agreement”) is a legal agreement between you (“User”) and Sparkle from Within LLC 
          (“Company,” “Resumate,” “we,” or “us”) governing your use of the Resumate mobile application and related services 
          (the “App”). By downloading, accessing, or using the App, you agree to be bound by this Agreement and Apple’s 
          standard EULA terms<a className='email cursor-pointer'> (https://www.apple.com/legal/internet-services/itunes/dev/stdeula/). </a>If you do not agree, do not use the App.
         </p>
       </header>
 
       <article>
         <h2 className='inner-heading'>1.  License Grant</h2>
          <ul className='terms-list'>
           <li>Resumate grants you a limited, non-exclusive, non-transferable, and revocable license to download and use the App for your personal, non-commercial use in accordance with this Agreement and our Terms of Use</li>

         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>2. User-Generated Content</h2>
          <ul className='terms-list'>
           <li>Resumate allows users to create and share resume-style profiles, video calls, and other personal content (“User Content”).
You retain ownership of your content but grant Resumate a worldwide, royalty-free license to use, display, and process your content for the purpose of operating, improving, and promoting the App.</li>
           <li>You are solely responsible for your content and agree that:</li>
           <li>You will not post false, misleading, or unlawful information.</li>

             <li>You will not include sensitive data (such as government IDs, addresses, or financial details).</li>
            <li>You will not upload any content that violates this Agreement, applicable laws, or another’s rights.</li>

         </ul>
       </article>
       
 
       <article>
         <h2 className='inner-heading'>3. No Tolerance for Objectionable Content or Abusive Users</h2>
          <ul className='terms-list'>
           <li>Resumate enforces a zero-tolerance policy for objectionable content and abusive behavior. You agree not to:</li>
           <li>Upload or share obscene, pornographic, violent, hateful, or discriminatory material.</li>
           <li>Harass, threaten, or abuse other users.</li>
           <li>Promote illegal activity or self-harm.</li>
           <li>Impersonate others or misrepresent your identity.</li>
           <li>Resumate reserves the right to remove objectionable content and permanently suspend or delete accounts that violate this policy.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>4. Content Moderation and User Safety</h2>
          <ul className='terms-list'>
           <li>Resumate employs both automated tools and human moderators to monitor and maintain a safe environment.The App provides:</li>
           <li>Filtering mechanisms to limit objectionable content.</li>
           <li>Reporting tools that allow users to flag inappropriate or abusive content.</li>
           <li>Blocking functions to prevent further contact from specific users.</li>
           <li>Reports of objectionable content are reviewed within 24 hours. Violating content and accounts are removed or restricted as appropriate.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>5.  Video Calls and Interactions</h2>
         <p>When using Resumate, you agree that you will not:</p>
          <ul className='terms-list'>
           <li>To promote safety, users must complete a video call before private chat access is enabled.</li>
           <li>Resumate does not conduct background checks and is not responsible for interactions or outcomes outside the App. Use caution and follow safe interaction practices.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>6. Termination</h2>
          <ul className='terms-list'>
           <li>You may delete your account at any time. Resumate may suspend or terminate your account without notice if you violate this Agreement or the Terms of Use. Termination includes removal of your User Content and loss of access to App features.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>7. Disclaimer</h2>
          <ul className='terms-list'>
           <li>The App is provided “as is” without any warranties, express or implied. Resumate does not guarantee matches, uninterrupted access, or compatibility with all devices.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>8. Limitation of Liability</h2>
          <ul className='terms-list'>
           <li>To the fullest extent permitted by law, Resumate and its affiliates shall not be liable for any indirect, incidental, or consequential damages arising from your use of the App, User Content, or interactions with other users.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>9. Indemnification</h2>
          <ul className='terms-list'>
           <li>You agree to indemnify and hold harmless Resumate, its affiliates, and employees from any claims, losses, or damages arising from your use of the App or violation of this Agreement.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>10. Governing Law</h2>
          <ul className='terms-list'>
           <li>This Agreement is governed by the laws of the State of Arizona, USA, without regard to conflict-of-law principles.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>11. Contact</h2>
         <p>For support, to report objectionable content, or for questions about this Agreement, contact</p>
          <p><a className='email'>info@resumate.org</a>
          <p>Sparkle from Within LLC</p>
<p>4539 N 22nd St, Ste N, Phoenix, AZ 85016</p>
         </p>
       </article>
        <article>
         <h2 className='inner-heading'>11. Entire Agreement</h2>
        <p>This EULA, together with the Terms of Use</p>
        <p> Privacy Policy</p>
        <p>and Community Guidelines, constitutes the entire agreement between you and Resumate.</p>
       </article>
 

       <footer className="terms-footer">
         © {new Date().getFullYear()} Resumate. All rights reserved.
       </footer>
       </div>
     </main>
      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                 <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EULA;

